<template>
  <div id="home">
    <div class="welcome" v-if="pageIndex == 4">
      <div class="welcomeContent">
        <div class="conss">
          <div class="picDiv">
            <div>
              <img src="../assets/imgs/icons/iconCamOk.png"/>
              <img src="../assets/imgs/icons/iconCamOkIcon.png"/>
            </div>
            <div>
              <img src="../assets/imgs/icons/iconCamError.png"/>
              <img src="../assets/imgs/icons/iconCamErrorIcon.png"/>
            </div>
          </div>
          <div class="picText">To get the best results, try <b>smiling naturally</b> with your upper teeth showing and avoid big or overly exaggerated smiles.</div>
          <div class="picBtn" @click="openOnline">Continue</div>
        </div>

        <p class="picBq">Copyright © {{moment().format('YYYY')}}  SMILEWISH Co. Ltd. All rights reserved</p>
      </div>
    </div>
    <div class="content" v-if="pageIndex == 0">
      <div class="form">
        <h1>Digital Smile Design</h1>
        <el-upload class="div" :auto-upload="false" accept="image/*" :show-file-list="false" action="ssss" :on-change="uploadFile">
          <div class="div1">
            Upload file
            <p>Upload your face photo to instantly explore personalized AI-generated smile designs. Discover your perfect smile with realistic, tailored previews!</p>
          </div>
          <img src="../assets/imgs/upload_div.png"/>
        </el-upload>
        <div class="div" @click="pageIndex = 4">
          <div class="div2">
            Live Camera
            <p>Take a picture of your smile, and let AI instantly generate your perfect smile design. See your best smile come to life in seconds!</p>
          </div>
          <img src="../assets/imgs/live_div.png"/>
        </div>
      </div>
    </div>
    <div class="liveContent" v-if="pageIndex == 1">
      <div class="videoBg">
        <div class="header">
          <i class="el-icon-back" @click="backHome"></i>
          <h1>
            Smile Camera
            <span>Please point the camera at the face area.</span>
          </h1>
          <i style="width:24px;"></i>
        </div>
        <div class="camera" @touchstart="handleTouchStart" @touchmove="handleTouchMove">
          <div class="lineCamera">
            <img src="../assets/imgs/line.png"/>
          </div>
          <div class="lineRadio">
            <div>
              <span></span>
              <span></span>
            </div>
            <div>
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="video" :style="flip_over_flag?'transform: scaleX(-1);':''">
            <video ref="video" autoplay webkit-playsinline="true" playsinline="true" x5-video-player-type="h5-page" ></video>
          </div>
          <canvas ref="canvas" style="display: none;"></canvas>
        </div>
        <div class="btnArea">
          <div style="width:30px;"></div>
          <div class="btn" @click="takePhoto">
            <span><i class="el-icon-camera"></i></span>
          </div>
          <div style="width:30px;">
            <i class="el-icon-refresh" style="color:#ffffff;font-size:40px;" @click="flip_over"></i>
          </div>
        </div>
      </div>
      <div class="videoBgCar" :style="flip_over_flag?'transform: scaleX(-1);':''">
        <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;overflow: hidden;">
          <video style="object-fit: cover;width: 100%;height: 100%;" ref="videoBg" autoplay webkit-playsinline="true" playsinline="true" x5-video-player-type="h5-page" ></video>
        </div>
      </div>
    </div>

    <div class="liveContent" :style="'background-image:url('+imageUrl+');'" v-if="pageIndex == 2">
      <div class="bg">
        <h1>Smile Camera<p>Please point the camera at the face area.</p></h1>
        <img ref="imgUrl" :src="imageUrl" style="position: absolute;left:-1200px;width: 800px;"/>
        <div class="img" :style="'background-image:url('+imageUrl+');'"></div>
        <div class="btnDiv">
          <span @click="pageIndex = 0">Try Again</span>
          <span @click="showLoading">Continue</span>
        </div>
      </div>
    </div>
    <div class="content" v-if="pageIndex == 3">
      <div class="menu">
        <span @click="pageIndex = 2"><i class="el-icon-arrow-left"></i>Back</span>
        <span @click="show_edit()"><i class="el-icon-download"></i>Save</span>
      </div>
      <div class="imgMain">
        <div class="div">
          <div class="img" :style="'background-image:url(' + (caseHistory.status == 'S3' ? getImgS3(caseHistory.oldImage) : getImg(caseHistory.oldImage)) + ');'"></div>
          <span>Original</span>
        </div>
        <div class="div">
          <div class="img" :style="'background-image:url(' + (caseHistory.statusNew == 'S3' ? getImgS3(caseHistory.newImage) : getImg(caseHistory.newImage)) + ');'">
            <div class="img" v-if="caseHistory.teethWhitening == 1" :style="'filter: brightness('+(caseHistory.brightness/50)+') saturate('+(caseHistory.saturate/50)+')  contrast('+(caseHistory.contrast/50)+');border:none;background-image:url('+(caseHistory.statusNew == 'S3' ? getImgS3(caseHistory.newImageMask) : getImg(caseHistory.newImageMask))+');'">
            </div>
          </div>
          <span>iDentSmile Pick</span>
        </div>
      </div>
      <div class="imgMain" v-if="caseHistory.teethWhitening == 1" style="margin-top:20px;">
        <div style="width: 100%;"></div>
        <div style="width: 100%;">
          <div style="display: flex;align-items: center;"><span style="flex-shrink: 0;width: 100px;">brightness:</span><el-slider :min="35" :max="65" style="width: 100%;" v-model="caseHistory.brightness"></el-slider></div>
          <div style="display: flex;align-items: center;"><span style="flex-shrink: 0;width: 100px;">saturate:</span><el-slider :min="35" :max="65" style="width: 100%;" v-model="caseHistory.saturate"></el-slider></div>
          <div style="display: flex;align-items: center;"><span style="flex-shrink: 0;width: 100px;">contrast:</span><el-slider :min="35" :max="65" style="width: 100%;" v-model="caseHistory.contrast"></el-slider></div>
        </div>
      </div>
      <div class="swiper">
        <swiper class="list pc" :options="swiperOption" ref="mySwiper" :class="caseHistory.results.length < 5 ? 'cent' : ''">
          <swiper-slide v-for="item,index in caseHistory.results" :key="index">
            <div class="item" :style="'background-image:url(' + (item.status == 'S3' ? getImgS3(item.image) : getImg(item.image)) + ');'" @click="changeNewImage(item)" :class="item.id == caseHistory.newImageId ? 'act' : ''"></div>
          </swiper-slide>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
        </swiper>
        <swiper class="list mobile" :options="swiperOptionMobile" ref="mySwiper">
          <swiper-slide v-for="item,index in caseHistory.results" :key="index">
            <div class="item" :style="'background-image:url(' + (item.status == 'S3' ? getImgS3(item.image) : getImg(item.image)) + ');'" @click="changeNewImage(item)" :class="item.id == caseHistory.newImageId ? 'act' : ''"></div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <save ref="editForm" @ok="resetPage"></save>
    </div>
    <el-dialog
      title="Processing"
      top="30vh"
      :show-close="false"
      :visible="dialogVisible"
      width="400px">
      <div style="display: flex;flex-direction: column;align-items: center;">
        <p v-if="caseHistory.id">Processing your request...Hang tight! This might take up to {{caseHistory.estimatedSecondsToCompletion}} seconds.</p>
        <p v-else>Processing your request...</p>
        <i class="el-icon-loading" style="font-size: 30px;margin:20px auto;"></i>
        <p style="color: #888888;margin:20px 0;" v-if="caseHistory.id">If you'd like to get alerts sent to your email and phone, just tap this button!</p>
        <el-button type="primary" style="background-color: #034844;border-color:#034844;padding:10px 20px;" @click="share" v-if="caseHistory.id">Notify Me</el-button>
      </div>
    </el-dialog>
    <share ref="shareForm" @ok="resetPage"></share>
    <share-account ref="shareAccountForm" @ok="resetPage"></share-account>
  </div>
</template>
<script>
  import Vue from 'vue';
  import Save from './orthodonticSmile/Save'
  import { swiper, swiperSlide } from "vue-awesome-swiper"
  import Share from './orthodonticSmile/Share'
  import ShareAccount from './orthodonticSmile/ShareAccount'
  import 'swiper/css/swiper.css'
  import { getAction, postAction } from '@/network/manage';
  import { getActionApi } from '@/network/manageApi';
  import html2canvas from 'html2canvas'
  import axios from 'axios'
  import moment from 'moment';
  export default {
    name: 'OrthodonticSmile',
    components: {
      Save,swiper,swiperSlide,Share,ShareAccount
    },
    data() {
      return {
        swiperOption:{
          slidesPerView: 5,
          spaceBetween: 10,
          loop: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        },
        swiperOptionMobile:{
          slidesPerView: 3,
          spaceBetween: 10,
          loop: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          }
        },
        dialogVisible: false,
        loadingValue:0,
        pageIndex:0,
        scale: 1,
        startDistance: 0,
        swiperIndex:0,
        imageUrl:'',
        caseHistory:{},
        flip_over_flag: true,
        cameraStream: null,
        fileNow:null,
        oldImage:null
      }
    },
    computed: {

    },
    created(){

    },
    watch: {
      scale(newScale) {
        this.$refs.video.style.transform = `scale(${newScale})`;
        this.$refs.videoBg.style.transform = `scale(${newScale})`;
      }
    },
    methods:{
      moment,
      getImgS3(key) {
        return process.env.VUE_APP_BASE_XA + '/sys/common/test/getImgS3?key=' + key
      },
      getImg(path) {
        return process.env.VUE_APP_BASE_XA + '/sys/common/test/view/' + path
      },
      show_edit() {
        this.$refs.editForm.init(this.oldImage,this.caseHistory.newImageId,this.caseHistory.id,this.caseHistory.brightness,this.caseHistory.saturate,this.caseHistory.contrast)
      },
      share() {
        this.$refs.shareAccountForm.init(this.caseHistory.id)
      },
      async flip_over() {
        this.stopCamera()
        if(this.flip_over_flag) {
          this.startDistance = 0
          this.scale = 1.5
          this.startBackCamera()
        } else {
          this.startDistance = 0
          this.scale = 1
          this.openOnline()
        }
        this.flip_over_flag = !this.flip_over_flag
      },
      showLoading(){
        const that = this
        that.dialogVisible = true
        that.caseHistory = {}
        getAction('/admin/caseHistory/addValidate').then((res) => {
          if(res.success){
            html2canvas(this.$refs.imgUrl,{scale: 1,}).then(canvas => {
              let imageUrl = canvas.toDataURL('image/png');
              postAction('/sys/common/test/uploadBase64',{base64Str:imageUrl.split(',')[1]}).then((res) => {
                if(res.success){
                  let oldPath = res.result.path
                  postAction('/admin/caseHistory/add',{oldImage:oldPath, teethWhitening:1}).then((res) => {
                    if(res.success){
                      that.$set(that.caseHistory,'id',res.result)
                      that.loadingCallBack()
                    }else{
                      that.$message.error(res.message);
                    }
                  }).catch((err) => {
                    that.$message.error(err.message);
                  })
                }else{
                  that.$message.error(res.message);
                }
              }).catch((err) => {
                that.$message.error(err.message);
              })

            })
          }else{
            this.$message.error('AI interface abnormality')
            that.dialogVisible = false
          }
        }).catch((err) => {
          this.$message.error('AI interface abnormality')
          that.dialogVisible = false
        })
      },
      async loadingCallBack(){
        const that = this
        if(this.caseHistory.newImage != null){
          for(let i = 0; i < this.caseHistory.results.length; i++){
            if(this.caseHistory.results[i].id == this.caseHistory.newImageId){
              this.$set(this.caseHistory,'newImageMask',this.caseHistory.results[i].imageMask);
            }
          }
          this.dialogVisible = false
          this.pageIndex = 3
        }else if(this.caseHistory.error){
          this.$message.error(this.caseHistory.error);
          this.dialogVisible = false
        }else{
          const res = await getAction('/admin/caseHistory/queryById?id=' + that.caseHistory.id)
          this.caseHistory = res.result
          setTimeout(function(){
            that.loadingCallBack()
          },1000)
        }
      },
      changeNewImage(item){
        this.$set(this.caseHistory,'statusNew',item.status);
        this.$set(this.caseHistory,'newImageId',item.id);
        this.$set(this.caseHistory,'newImage',item.image);
        for(let i = 0; i < this.caseHistory.results.length; i++){
          if(this.caseHistory.results[i].id == this.caseHistory.newImageId){
            this.$set(this.caseHistory,'newImageMask',this.caseHistory.results[i].imageMask);
          }
        }
      },
      async openOnline(){
        this.pageIndex = 1
        this.flip_over_flag = true
        this.startDistance = 0
        this.scale = 1
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: true,
          });
          this.cameraStream = stream;
          this.$refs.video.srcObject = stream;
          this.$refs.videoBg.srcObject = stream;
        } catch (error) {
          console.error(error);
        }
      },
      handleTouchStart(event) {
        if (event.touches.length === 2 && !this.flip_over_flag) {
          const [touch1, touch2] = event.touches;
          this.startDistance = Math.hypot(touch2.pageX - touch1.pageX, touch2.pageY - touch1.pageY);
        }
      },
      handleTouchMove(event) {
        if (event.touches.length === 2 && !this.flip_over_flag) {
          const [touch1, touch2] = event.touches;
          const currentDistance = Math.hypot(touch2.pageX - touch1.pageX, touch2.pageY - touch1.pageY);
          const scaleFactor = currentDistance / this.startDistance;
          this.scale *= scaleFactor;
          if(this.scale < 1)
            this.scale = 1
          this.startDistance = currentDistance;
        }
      },
      async startBackCamera() {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: { facingMode: { exact: "environment" } },
          });
          this.cameraStream = stream;
          this.$refs.video.srcObject = stream;
        } catch (error) {
          console.error(error);
        }
      },
      backHome(){
        this.stopCamera()
        this.pageIndex = 0
      },
      resetPage(){
        this.$router.push('/caseHistory')
      },
      stopCamera() {
        if (this.cameraStream) {
          this.cameraStream.getTracks()[0].stop();
          this.cameraStream = null;
        }
      },
      uploadFile(file, fileList){
        this.imageUrl = URL.createObjectURL(file.raw)
        this.fileNow = file.raw
        this.pageIndex = 2
      },
      takePhoto(){
        const video = this.$refs.video
        const canvas = this.$refs.canvas
        const context = canvas.getContext('2d')
        if(this.flip_over_flag){
          canvas.width = this.$refs.video.videoWidth
          canvas.height = this.$refs.video.videoHeight
          context.translate(canvas.width, 0);
          context.scale(-1, 1);
          context.drawImage(video, 0, 0, canvas.width, canvas.height)
        }else{
          canvas.width = this.$refs.video.videoWidth/this.scale
          canvas.height = this.$refs.video.videoHeight/this.scale
          const x = (this.$refs.video.videoWidth - this.$refs.video.videoWidth/this.scale) * 0.5
          const y = (this.$refs.video.videoHeight - this.$refs.video.videoHeight/this.scale) * 0.5
          context.drawImage(video, x, y, this.$refs.video.videoWidth/this.scale, this.$refs.video.videoHeight/this.scale,0,0,this.$refs.video.videoWidth/this.scale, this.$refs.video.videoHeight/this.scale)
        }
        this.imageUrl = canvas.toDataURL("image/png")
        this.pageIndex = 2
        this.stopCamera()
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{padding:20px;}
  .content{background-color: #ffffff;padding:20px;border-radius: 12px;display: flex;flex-direction: column;align-items: center;}
  .form{border:1px solid #717D96;border-radius: 7px;padding:20px;}
  .content h1{font-size: 40px;margin-bottom: 20px;}
  .content .div{cursor: pointer;}
  .div1{position: absolute;color:#ffffff;width: 340px;font-size: 30px;font-weight: bold;margin-left:640px;margin-top:100px;}
  .div1 p{font-size: 12px;font-weight: normal;line-height: 1.5;}
  .div2{position: absolute;color:#ffffff;width: 360px;font-size: 30px;font-weight: bold;padding:20px 0 0 20px;}
  .div2 p{font-size: 12px;font-weight: normal;line-height: 1.5;}
  .liveContent{width:1035px;border-radius:38px;margin:auto;overflow: hidden;height: calc(100vh - 110px);background-size:auto 130%;background-position: center;background-repeat: no-repeat;background-position: center;}
  .liveContent .bg{background-color: rgba(0, 0, 0, 0.6);width: 100%;height: 100%;display: flex;flex-direction: column;align-items: center;}
  .liveContent .bg h1{color:#ffffff;font-size: 30px;display: flex;flex-direction: column;width: 100%;padding-left:30px;margin:10px 0;}
  .liveContent .bg h1 p{font-size: 12px;font-weight: normal;}
  .liveContent .bg .img{width: 500px;height: 580px;background-size: cover;background-position: center;}
  .liveContent .bg .btnDiv{display: flex;justify-content: center;}
  .liveContent .bg .btnDiv span{width: 130px;height: 32px;border-radius: 4px;cursor: pointer;background-color: #E0ECFF;font-size: 14px;color: #1E1E1E;display: flex;justify-content: center;align-items: center;margin:20px;}
  .liveContent .bg .btnDiv span:last-child{background-color: #9ABDBD;color:#ffffff;}
  .swiper{display: flex;align-items: center;margin:30px 0;}
  .swiper span{border:1px solid #D9D9D9;width: 20px;height: 20px;cursor: pointer;display: flex;align-items:center;justify-content: center;font-size: 12px;color: #D9D9D9;margin: 0 10px;border-radius: 4px;}
  .swiper .list{width: 730px;overflow: hidden;height:180px;}
  .swiper .list .item{opacity: 0.7;cursor: pointer;height: 180px;background-size: cover;border:1px solid #D9D9D9;border-radius: 4px;overflow: hidden;flex-shrink: 0;background-position: center;}
  .swiper .list .act{opacity: 1;border:5px solid #8BB2B2;}
  .swiper-button-prev{transform:scale(0.6);margin-top:-20px;}
  .swiper-button-next{transform:scale(0.6);margin-top:-20px;}
  .imgMain{width: 860px;display: flex;align-items: center;}
  .imgMain .div{width: 100%;display: flex;flex-direction: column;align-items: center;cursor: default !important;}
  .imgMain .div:first-child{margin-right: 1px;}
  .imgMain .div .img{height: 460px;width: 100%;background-size: cover;background-position: center;}
  .imgMain .div span{width: 250px;height: 44px;border-radius: 4px;display: flex;align-items: center;justify-content: center;margin-top:10px;}
  .imgMain .div:first-child span{border:1px solid #BCBEC0;color: #979797;}
  .imgMain .div:last-child span{border:1px solid #8BB2B2;color: #ffffff;background-color: #8BB2B2;}
  .menu{display: flex;justify-content: flex-end;width: 100%;margin-bottom:20px;}
  .menu span{width: 120px;height: 40px;border-radius: 4px;display: flex;align-items: center;justify-content: center;cursor: pointer;}
  .menu span i{margin-right: 5px;}
  .menu span:first-child{border:1px solid #797979;color:#868989;}
  .menu span:last-child{background-color: #034844;color:#ffffff;margin-left:10px;}
  .mobile{display: none;}
  .videoBg{position: absolute;z-index:1;background-color:rgba(0, 0, 0, 0.6);position: absolute;width:1035px;height: calc(100vh - 110px);border-radius:38px;display: flex;flex-direction: column;align-items: center;}
  .videoBgCar{width:1035px;height: calc(100vh - 110px);border-radius:38px;}
  .videoBg .header{color:#ffffff;display: flex;padding:20px;width: 100%;}
  .videoBg .header i{font-size: 24px;flex-shrink: 0;cursor: pointer;}
  .videoBg .header h1{font-size: 36px;width: 100%;padding-left:20px;line-height: 1;font-weight: normal;display: flex;flex-direction: column;}
  .videoBg .header h1 span{font-size: 14px;margin-top:6px;}
  .videoBg .camera{width: 500px;height: 580px;}
  .video{width: 500px;height: 580px;display: flex;align-items: center;justify-content: center;overflow: hidden;z-index:6;position: absolute;}
  .videoBg .camera video{width: 500px;position: absolute;z-index:6;height: 580px;object-fit: cover;}
  .btnArea{display: flex;align-items: center;justify-content: space-between;width:500px;padding:0 20px;}
  .videoBg .lineRadio{position: absolute;width: 510px;height: 590px;z-index:5;margin-left:-5px;margin-top:-5px;display: flex;justify-content:space-between;flex-direction: column;}
  .videoBg .lineRadio div{display: flex;justify-content: space-between;}
  .videoBg .lineRadio span{background-color:#3EA19D;width:80px;height:80px;border-radius: 10px;}
  .videoBg .lineCamera{position: absolute;width: 500px;height: 580px;display: flex;align-items: center;justify-content: center;z-index:7;}
  .videoBg .lineCamera img{margin-top:80px;width: 300px;}
  >>>.el-upload{display: flex;flex-direction: column;text-align: left;}
  >>>.cent .swiper-wrapper{justify-content: center;}
  .videoBg .btn{flex-shrink:0;background-color: rgba(254, 254, 254, 0.6);margin-top:10px;width: 100px;height: 100px;border-radius: 50%;overflow: hidden;padding:8px;display: flex;}
  .videoBg .btn span{width: 84px;height: 84px;border:4px solid #424242;background-color: #9ABDBD;font-size: 50px;color:#ffffff;cursor: pointer;border-radius: 50%;display: flex;justify-content: center;align-items: center;}
  .welcome{display: flex;align-items: center;justify-content: center;height: calc(100vh - 110px);}
  .welcomeContent{background-color: #F9F3EE;border:5px solid #97A295;border-radius: 10px;padding:50px;width:700px;}
  .conss{background:#ffffff;padding:20px 40px 40px 40px;border-radius: 20px;display: flex;flex-direction: column;align-items: center;}
  .picDiv{display: grid;border-radius: 10px;overflow: hidden;grid-template-columns: 1fr 1fr;grid-column-gap: 20px;}
  .picDiv div{display: flex;flex-direction: column;align-items: center;}
  .picDiv div img:nth-child(1){width: 173px;height: 194px;}
  .picDiv div img:nth-child(2){margin-top: 10px;}
  .picBtn{background-color: #3EA19D;width: 137px;height: 44px;color:#ffffff;cursor: pointer;display: flex;align-items: center;justify-content: center;font-size: 14px;border-radius: 4px;}
  .conss .picText{padding:0 30px;margin:20px 0;font-size: 20px;color: #1A202C;}
  .picBq{text-align: center;color: #A0AEC0;font-size: 12px;margin-top: 20px;}
  @media (max-width: 768px) {
    .welcomeContent{width:90vw;padding:20px;}
    .conss{padding:20px;}
    .conss .picText{padding:0 10px;margin:10px 0;font-size: 16px;color: #1A202C;}
    .picDiv div img:nth-child(1){width: 30vw;height:auto;}
    .picDiv div img:nth-child(2){width: 10vw;}
    #home{padding:0;}
    .pc{display: none;}
    .mobile{display: inherit;}
    .content{border-radius: 0;min-height:calc(100vh - 70px);display: flex;align-items: center;justify-content: flex-start;}
    .content .div img{width: 100%;}
    .div{display: flex;flex-direction: column;margin-top: 5vw;}
    .content h1{font-size: 20px;margin-bottom: 20px;}
    .div1{color:#ffffff;width:auto;align-self: flex-end;margin-top:9.4vw;font-size: 16px;font-weight: bold;display: flex;justify-content: flex-end;flex-direction:column;margin-left:0;margin-right: 10px;;}
    .div1 p{display: none;}
    .div2{position: absolute;color:#ffffff;width: 50vw;font-size: 16px;font-weight: bold;padding:2px 0 0 6px;margin-top:2.6vw;}
    .div2 p{display: none;}
    .liveContent{width:100%;height:90vh;border-radius: 0;}
    .videoBg{width:100vw;height:90vh;border-radius: 0;}
    .videoBgCar{width:100%;height: 90vh;border-radius: 0;}
    .liveContent .bg h1{font-size: 20px;padding-left:20px;}
    .imgMain{width: 100%;flex-direction: column;}
    .imgMain .div:first-child{margin-right: 0;}
    .videoBg .camera{width: 80vw;height:56vh;margin:6px 0;}
    .videoBg .camera video{width: 80vw;height: 56vh;}
    .video{width: 80vw;height: 56vh;display: flex;align-items: center;justify-content: center;overflow: hidden;}
    .videoBg .lineRadio{width: calc(80vw + 6px);height:calc(56vh + 6px);margin-left:-3px;margin-top:-3px;}
    .videoBg .lineRadio span{width:50px;height:50px;border-radius: 6px;}
    .videoBg .lineCamera{width: 80vw;height: 56vh;}
    .videoBg .lineCamera img{width: 50vw;margin-top:50px;}
    .videoBg .btn{margin-top:5px;width: 80px;height: 80px;padding:5px;}
    .videoBg .btn span{width: 70px;height: 70px;border:4px solid #424242;font-size: 40px;}
    .swiper{width:96vw;margin-bottom:0;}
    .swiper .list{width:96vw;}
    .swiper .list .item{height:150px;}
    .menu{margin-bottom:0;}
    .btnArea{width:90%;}
    >>>.cent .swiper-wrapper{justify-content: flex-start;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .content .div img{width: 100%;}
    .div{display: flex;flex-direction: column;}
    >>>.el-upload{display: flex;flex-direction: column;text-align: left;}
    .div1{color:#ffffff;width:auto;align-self: flex-end;margin-top:7vw;font-size: 20px;font-weight: bold;display: flex;justify-content: flex-end;flex-direction:column;margin-left:0;}
    .div1 p{line-height: 1.2;margin-top:10px;width: 27vw;}
    .div2{position: absolute;color:#ffffff;width: 27vw;font-size: 20px;font-weight: bold;padding:2px 0 0 10px;}
    .div2 p{line-height: 1.2;}
    .liveContent{width:100%;}
    .videoBg{width:calc(100vw - 90px - 40px);}
    .videoBgCar{width:100%;}
    .imgMain{width: 100%;}
    .btnArea{width:80%;}
    .swiper{width:calc(100vw - 90px - 80px);}
    .swiper .list{width:calc(100vw - 90px - 80px);}
    .liveContent .bg .img{width: 80%;height:70vh;}
    .videoBg .lineCamera img{width: 70%;margin-top:50px;}
    .videoBg .camera{width: 80%;height:70vh;}
    .videoBg .lineCamera{width: 80%;height:70vh;}
    .videoBg .camera video{width: 100%;height:70vh;}
    .video{width: 80%;height:70vh;display: flex;align-items: center;justify-content: center;overflow: hidden;}
    .videoBg .header i{font-size:30px;}
    .videoBg .lineRadio{width: calc(80% + 10px);height:calc(70vh + 10px);}
    >>>.cent .swiper-wrapper{justify-content: center;}
  }
</style>
